import { gql } from '@apollo/client';

import { item } from './fragments/item';

export const allItemsQuery = gql`
  query allItems($where: ItemFilter) {
    allItem(where: $where) {
      ... on Item {
        ...ItemFragment
        description {
          localeRaw: _LANG_Raw
        }
      }
    }
  }
  ${item}
`;
